export default "__VITE_ASSET__43k22fzo__"